import { render, staticRenderFns } from "./CustomersAll.vue?vue&type=template&id=8a566dbc&"
import script from "./CustomersAll.vue?vue&type=script&lang=js&"
export * from "./CustomersAll.vue?vue&type=script&lang=js&"
import style0 from "./CustomersAll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports